var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup431(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 160,
    viewBox: "0 0 283 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2247_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 5.90918,
    width: 268,
    height: 149.091,
    rx: 12,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2247_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 268,
    height: 149.091,
    rx: 12,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.158 57V109.5H142.496V117H211.51V57H201.158Z",
    fill: "#4DE0F9",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M210.127 115.5H79V68.25L79.0008 52.5L210.127 51V115.5ZM83.1408 111H205.986V55.5L83.1408 56.5V66.75V111Z",
    fill: "#0D5FC3",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3555 61.5V105.75H98.3273V103.125C98.3273 96 103.848 90 110.405 90C116.961 90 122.482 96 122.482 103.125V105.75H130.074V61.5H89.3555ZM110.06 87C105.229 87 101.433 82.5 101.433 77.25C101.433 72 105.574 67.875 110.405 67.875C115.236 67.875 119.032 72.375 119.032 77.625C119.032 82.875 114.891 87 110.06 87Z",
    fill: "#4DE0F9",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.404 89.25C107.299 89.25 104.538 88.125 102.813 85.875C100.742 83.625 99.707 80.625 99.707 77.625C99.707 71.25 104.538 66 110.749 66C116.615 66 121.446 71.25 121.446 78C121.101 84 116.27 89.25 110.404 89.25ZM110.404 70.125C106.608 70.125 103.848 73.5 103.848 77.25C103.848 79.125 104.538 81 105.918 82.5C107.299 84 108.679 84.75 110.749 84.75C114.545 84.75 117.306 81.375 117.306 77.625C116.961 73.5 114.2 70.125 110.404 70.125Z",
    fill: "#0D5FC3",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.556 105.375H120.415V102.75C120.415 99.75 119.38 97.125 117.655 94.875C115.929 92.625 113.169 91.5 110.753 91.5C105.232 91.5 100.746 96.375 100.746 102.375V105H96.6055V102.375C96.6055 93.75 103.162 87 111.098 87C114.894 87 118.345 88.875 121.105 91.5C123.866 94.125 125.246 98.25 125.246 102.375V105.375H124.556Z",
    fill: "#0D5FC3",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155.261 68.25H143.184V72.75H155.261V68.25Z",
    fill: "#0D5FC3",
    fillOpacity: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M155.261 81H143.184V85.5H155.261V81Z",
    fill: "#0D5FC3",
    fillOpacity: 0.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M155.261 94.125H143.184V98.625H155.261V94.125Z",
    fill: "#0D5FC3",
    fillOpacity: 0.4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M184.94 68.25H162.855V72.75H184.94V68.25Z",
    fill: "#0D5FC3",
    fillOpacity: 0.4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M192.877 81H162.855V85.5H192.877V81Z",
    fill: "#0D5FC3",
    fillOpacity: 0.4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M192.877 94.125H162.855V98.625H192.877V94.125Z",
    fill: "#0D5FC3",
    fillOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2247_2",
    x: 7,
    y: 2.90918,
    width: 276,
    height: 157.091,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2247_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2247_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2247_2",
    x: 0,
    y: 0,
    width: 276,
    height: 157.091,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2247_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2247_2",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup431);
export default __webpack_public_path__ + "static/media/Group 431.088758ec94aedb7bc0e72604565720ff.svg";
export { ForwardRef as ReactComponent };